import { AmountDisplay, useFixedAmountInput } from '@onomy/react-hub';
import React from 'react';

import { useModal } from 'context/modal/ModalContext';
import { useExchange } from 'context/exchange/ExchangeContext';
import {
  ExchangeItem,
  FlexDiv,
  AvailableDiv,
  Sending,
  SendingBox,
  SendingBoxLabel,
  ExchangeInput,
  MaxBtn,
  Receiving,
  ReceivingValue,
  SymbolDisplay,
  SellBtn,
} from './exchangeStyles';
import { getFirstMessage } from 'utils/helpers';

export function SellBridgeNomQuote() {
  const { onShowConfirmSell } = useModal();
  const {
    ethQuote,
    bNomBalance,
    bNomAskAmountFixed,
    toggleSellMaxAmount,
    setBNomAskAmountFixed,
    extraAllowanceNeeded,
    sellCanSubmit,
    sellFormErrors,
  } = useExchange();

  const [displayValue, setDisplayValue] = useFixedAmountInput({
    value: bNomAskAmountFixed,
    onChangeValue: setBNomAskAmountFixed,
    meta: bNomBalance.asset.meta,
  });

  const errorMessage = displayValue && getFirstMessage(sellFormErrors);

  return (
    <ExchangeItem>
      <FlexDiv>
        <strong>Sell {bNomBalance.asset.meta.symbol}</strong>
        <AvailableDiv>
          Available: <AmountDisplay balance={bNomBalance} SymbolComponent={SymbolDisplay} />
        </AvailableDiv>
      </FlexDiv>
      <Sending>
        <SendingBoxLabel style={{ width: '100%', paddingRight: 16 }}>
          <strong>Amount</strong>
          <ExchangeInput
            type="text"
            data-testid="exchange-strong-balance-input"
            onChange={evt => setDisplayValue(evt.target.value)}
            value={displayValue}
            placeholder="0.00"
          />
          {bNomBalance.asset.meta.symbol}
        </SendingBoxLabel>
        <SendingBox>
          <MaxBtn data-testid="max-value-button" onClick={toggleSellMaxAmount}>
            Max
          </MaxBtn>
        </SendingBox>
      </Sending>
      <Receiving>
        <strong>You will receive</strong>
        <ReceivingValue data-testid="exchange-weak-balance">
          {ethQuote.amount > 0 ? (
            <AmountDisplay balance={ethQuote} SymbolComponent={SymbolDisplay} />
          ) : (
            <SymbolDisplay symbol={ethQuote.asset.meta.symbol} />
          )}
        </ReceivingValue>
      </Receiving>
      {extraAllowanceNeeded.amount > 0 ? (
        <SellBtn onClick={() => onShowConfirmSell()} disabled={!sellCanSubmit}>
          {errorMessage || 'Approve'}
        </SellBtn>
      ) : (
        <SellBtn onClick={() => onShowConfirmSell()} disabled={!sellCanSubmit}>
          {errorMessage || <>Sell {bNomBalance.asset.meta.symbol}</>}
        </SellBtn>
      )}
    </ExchangeItem>
  );
}
